import React, { useState } from "react";
import {
  Box,
  Container,
  useTheme,
  useMediaQuery,
  IconButton,
  Typography,
} from "@mui/material";
import CategoryItem from "../Category/CategoryItem";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";

export default function Navigation({
  categories = [],
  handleCategorySelection,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      component="nav"
      aria-label="دسته بندی محصولات"
      sx={{
        width: "100%",
        bgcolor: "#ffffff",
        borderBottom: "1px solid",
        borderColor: "grey.200",
        direction: "rtl",
      }}
    >
      <Container maxWidth="xl" disableGutters={isMobile}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            py: { xs: 0.8, md: 0.5 },
            px: { xs: 1.5, md: 0 },
            // Mobile horizontal swipe configuration
            overflowX: isMobile ? "auto" : "visible",
            whiteSpace: isMobile ? "nowrap" : "normal",
            scrollSnapType: isMobile ? "x mandatory" : "none",
            WebkitOverflowScrolling: "touch",
            "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar
            scrollbarWidth: "none",
            gap: { xs: 1, md: 1.5 },
          }}
        >
          {categories.map((cat) => (
            <Box
              key={cat.slug}
              sx={{
                flexShrink: 0,
                scrollSnapAlign: "start",
              }}
            >
              <CategoryItem cat={cat} onSelect={handleCategorySelection} />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
